import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import Card from '../components/Card';

import Button from '@material-ui/core/Button';

import ButtonGroup from '../components/ButtonGroup';
import InsulatedButton from '../components/InsulatedButton';

import { CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_DUCT, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, changeType } from '../modules/calculation';

import { patchProject } from '../modules/project';

import { getUIText } from '../utils/index';

const customStyles = {
  content: {
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    height: '160px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
  },
};

Modal.setAppElement('#root');

class CalculationType extends Component {

  state = {
    modalIsOpen: false,
    marineCheck: null,
  }

  onTypeChange = type => {
    const {
      onTypeChange,
      project,
    } = this.props;

    const {
      useMarineProducts,
    } = project ? project : {};

    onTypeChange(type);
  }

  onUseMarineSelection = (type, event) => {
    const {
      onUseMarineSelection,
    } = this.props;

    onUseMarineSelection(event.target.checked);
  }

  onMarineOnUseClickHandler = (checked) => {
    const {
      onUseMarineSelection,
    } = this.props;

    onUseMarineSelection(!checked);
  }

  openModal(checked) {
    this.setState({marineCheck: checked});
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  closeModal(type) {
    const {
      onUseMarineSelection,
    } = this.props;

    this.setState({modalIsOpen: false});
    if(type === 'OK') {
      if(this.state.marineCheck) {
        onUseMarineSelection(false);
        this.setState({marineCheck: false});
      } else {
        onUseMarineSelection(true);
        this.setState({marineCheck: true});
      }
    }
  }

  render() {
    const {
      app,
      project,
      translations,
      onCreateProjectClick,
      onTypeChange,
    } = this.props;

    const {
      calculations,
      calculationIndex,
      useMarineProducts
    } = project;

    const {
      sectionIndex,
      sections,

      type,
     } = calculations ? calculations[calculationIndex] : {};

     const {

     } = sections ? sections[sectionIndex] : {};

    let subButtonGroup;
 // onClick={this.onMarineOnUseClickHandler.bind(this, useMarineProducts)}>
    return (
      <div>
        <Card title={getUIText('CALCULATION-SELECT_OBJECT', app.language, translations)} className="card-new-calculation" iconClass="fa fa-plus-square">
          <div className="insulated-object">
            {/* UNCOMMENT THIS WHEN MARINE IS ADDED BACK TO THE APP */}
            {/* <div className="marine-icon-holder" onClick={this.openModal.bind(this, useMarineProducts)}>
              <Checkbox
                checked={useMarineProducts}
              />
              <img src={marineIcon} />
              <label>{getUIText("CALCULATION-USE_MARINE_PRODUCTS", app.language, translations)}</label>
            </div> */}
          {/*   */}
            <ButtonGroup onChange={this.onTypeChange.bind(this)} >
              <InsulatedButton label={getUIText('CALCULATION-FLAT_SURFACE', app.language, translations)} selected={type === CALCULATION_TYPE_PLANE ? true : false} type={CALCULATION_TYPE_PLANE} />
              <InsulatedButton label={getUIText('CALCULATION-PIPE', app.language, translations)} selected={type === CALCULATION_TYPE_PIPE ? true : false} type={CALCULATION_TYPE_PIPE} />
              <InsulatedButton label={getUIText('CALCULATION-DUCT', app.language, translations)} selected={(type === CALCULATION_TYPE_DUCT || type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) ? true : false} type={CALCULATION_TYPE_DUCT} />
              <InsulatedButton label={getUIText('CALCULATION-CIRCULAR_TANK', app.language, translations)} selected={type === CALCULATION_TYPE_VERTICAL_TANK ? true : false} type={CALCULATION_TYPE_VERTICAL_TANK} />
              <InsulatedButton label={getUIText('CALCULATION-CIRCULAR_TANK', app.language, translations)} selected={type === CALCULATION_TYPE_HORIZONTAL_TANK ? true : false} type={CALCULATION_TYPE_HORIZONTAL_TANK} />
              <InsulatedButton label={getUIText('CALCULATION-RECTANGULAR_TANK', app.language, translations)} selected={type === CALCULATION_TYPE_RECTANGULAR_TANK ? true : false} type={CALCULATION_TYPE_RECTANGULAR_TANK} />
            </ButtonGroup>
            {subButtonGroup}
          </div>
        </Card>
          <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal">

          <h2 style={{color: 'rgb(102, 102, 102)', fontSize: '1.3rem'}}>{getUIText('CALCULATION-SWITCH-MARINE-TITLE', app.language, translations)}</h2>
          <p style={{color: 'rgba(0, 0, 0, 0.54)', fontSize: '1rem'}}>
          {getUIText('CALCULATION-SWITCH-MARINE', app.language, translations)}
          </p>
          <Button onClick={this.closeModal.bind(this, 'CANCEL')} color="primary">
            {getUIText('GENERAL-CANCEL', app.language, translations)}
          </Button>
          <Button onClick={this.closeModal.bind(this, 'OK')} color="primary" autoFocus>
            {getUIText('GENERAL-OK', app.language, translations)}
          </Button>

        </Modal>
      </div>
    );
  }
}

CalculationType.propTypes = {
    project: PropTypes.object,
    translations: PropTypes.object,
    app: PropTypes.object,
  onTypeChange: PropTypes.any,
  onUseMarineSelection: PropTypes.any,
  onCreateProjectClick: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      project: state.project,
      translations: state.translations,
      app: state.app,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      // onCreateProjectClick: (calc) => dispatch(createCalculation(calc))
      onTypeChange: (type) => {
        dispatch(changeType({ type: type }));
      },
      onUseMarineSelection: useMarineProducts => {
        dispatch(patchProject({ useMarineProducts }));
      },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CalculationType);
